<template>
  <v-table
    class="elevation-5 rounded-t-lg"
    v-if="projectsCompareList.length > 0"
    style="width: 75%; margin: auto"
  >
    <thead>
      <tr>
        <th
          style="background-color: #0d47a1; color: #fff !important"
          colspan="2"
        >
          Projects to be compared
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="project in projectsCompareList" :key="project.id">
        <td>{{ project.name }}</td>
      </tr>
      <tr v-if="projectsCompareList.length > 1">
        <td colspan="2" class="compare-btn">
          <LinkButton
            v-if="hasLessThanThreeProjects()"
            :route="
              $routes.projects_compare({
                project1: getProject(0).id,
                project2: getProject(1).id,
              })
            "
            text="Compare"
          >
          </LinkButton>
          <LinkButton
            v-else-if="hasLessThanFourProjects()"
            :route="
              $routes.projects_compare({
                project1: getProject(0).id,
                project2: getProject(1).id,
                project3: getProject(2).id,
              })
            "
            text="Compare"
          >
          </LinkButton>
          <LinkButton
            v-else-if="hasFourProjects()"
            :route="
              $routes.projects_compare({
                project1: getProject(0).id,
                project2: getProject(1).id,
                project3: getProject(2).id,
                project4: getProject(3).id,
              })
            "
            text="Compare"
          >
          </LinkButton>
        </td>
      </tr>
      <tr v-else>
        <td colspan="2" style="padding: 0">
          <v-alert
            type="info"
            text="Add one more project to compare"
            variant="tonal"
          ></v-alert>
        </td>
      </tr>
    </tbody>
  </v-table>
</template>

<script setup>
import LinkButton from "@/Shared/LinkButton.vue";
import * as $routes from "@/packs/routes";

const props = defineProps({
  projectsCompareList: {
    type: Array,
    required: true,
  },
});

function getProject(index) {
  return props.projectsCompareList[index];
}
function hasLessThanThreeProjects() {
  return props.projectsCompareList.length < 3;
}
function hasLessThanFourProjects() {
  return (
    props.projectsCompareList.length < 4 && props.projectsCompareList.length > 0
  );
}
function hasFourProjects() {
  return (props.projectsCompareList.length = 4);
}
function removeComparable(id) {
  const projectIndex = props.projectsCompareList.findIndex((p) => p.id === id);
  props.projectsCompareList.splice(projectIndex, 1);
}
</script>

<style scoped></style>
